// extracted by mini-css-extract-plugin
export default {"nextBtn":"NextStep_nextBtn__UwjTE","customButton":"NextStep_customButton__GNDCR","padding":"NextStep_padding__vmUUS"};